<template>
  <div class="header">
    <h1>問卷列表</h1>
    <div class="d-flex align-items-center col-9 justify-content-end">
      <button
        v-if="isButtonShow('questionnaire/create')"
        @click="$router.push('/edit-classification')"
        class="btn btn-outline-primary col-5 add-que me-5"
      >
        新增問卷
      </button>
    </div>
  </div>
  <div class="position-relative d-flex align-items-center col-4 mt-4">
    <CFormInput
      class="rounded-pill"
      type="text"
      placeholder="請輸入問卷名稱"
      v-model="searchTitle"
      @input="SearchTitleChante"
    />
  </div>
  <CRow class="my-5 fw-bold col-12 mx-auto list-title">
    <CCol xs="3" class="text-center">問卷名稱</CCol>
    <CCol xs="2" class="text-center text-nowrap">問卷創建日期</CCol>
    <CCol xs="1" class="text-center text-nowrap">發布狀態</CCol>
    <CCol xs="1" class="text-center text-nowrap">問卷分析</CCol>
    <CCol xs="5" class="text-center text-nowrap"></CCol>
  </CRow>
  <CRow
    v-for="item in list"
    :key="item.name"
    class="mb-4 border list d-flex align-items-center col-12 mx-auto"
  >
    <CCol
      xs="3"
      class="text-center"
      style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
      >{{ item.title }}</CCol
    >
    <CCol xs="2" class="text-center">{{ formatTimestamp(item.created) }}</CCol>
    <CCol xs="1" class="text-center">
      <div
        class="state"
        :style="
          item.status === '0'
            ? 'background: #FE988E;'
            : item.status === '1'
            ? 'background: #74D39C;'
            : 'background: #9CA0A8;'
        "
      >
        {{
          item.status === '0'
            ? '未發布'
            : item.status === '1'
            ? '已發布'
            : '下架'
        }}
      </div>
    </CCol>
    <CCol xs="1" class="d-flex align-items-center justify-content-center">
      <button
        v-if="isButtonShow('questionnaire/report')"
        :disabled="!canViewAnalyze(item) || +item.is_archive"
        @click="!canViewAnalyze(item) ? '' : toAnalyze(item.id)"
        :class="!canViewAnalyze(item) ? 'btn-light' : 'btn-primary'"
        class="border-0 btn btn-primary result"
      >
        問卷分析
      </button>
    </CCol>
    <CCol xs="5" class="d-flex align-items-center justify-content-center">
      <template v-if="isButtonShow('questionnaire/edit-part')">
        <CPopover
          v-if="item.status !== '0'"
          content="問卷狀態為下架或發布無法進行編輯"
          placement="bottom"
          trigger="hover"
        >
          <template #toggler="{ on }">
            <CButton
              color="light"
              v-on="on"
              class="list-btn text-nowrap"
              :disabled="+item.is_archive"
            >
              編輯
              <img src="@/assets/icons/edit.svg" alt="" />
            </CButton>
          </template>
        </CPopover>
        <CButton
          v-else
          color="light"
          @click="$router.push(`/edit-classification/${item.id}`)"
          :disabled="+item.is_archive"
          class="list-btn text-nowrap"
        >
          編輯
          <img src="@/assets/icons/edit.svg" alt="" />
        </CButton>
      </template>

      <CButton
        v-if="isButtonShow('questionnaire/copy')"
        color="light"
        class="list-btn mx-2 text-nowrap"
        :disabled="+item.is_archive"
        @click="copyQue(item.id)"
      >
        複製
        <img src="@/assets/icons/copy-que.svg" alt="" />
      </CButton>
      <CButton
        v-if="isButtonShow('questionnaire/arch')"
        color="light"
        class="list-btn text-nowrap"
        @click="archiveQue(item.id, item.is_archive)"
      >
        {{ +item.is_archive ? '解封' : '封存' }}
        <img src="@/assets/icons/arch.svg" alt="" />
      </CButton>
      <CButton
        v-if="isButtonShow('questionnaire/delete')"
        color="light"
        class="list-btn text-nowrap ms-2"
        @click="deleteQue(item.id)"
      >
        刪除
        <img src="@/assets/icons/delete.svg" alt="" />
      </CButton>
      <CButton
        v-if="isButtonShow('questionnaire/publish')"
        color="light"
        class="list-btn text-nowrap ms-2"
        :disabled="+item.is_archive"
        @click="publishQue(item.id, item.status)"
      >
        {{ item.status === '1' ? '下架' : '發布' }}
        <img
          v-if="item.status !== '1'"
          src="@/assets/icons/publish.svg"
          alt=""
        />
        <img v-else src="@/assets/icons/archive.svg" alt="" />
      </CButton>
      <CButton
        color="light"
        :disabled="item.status == '0' || item.status == '2' || +item.is_archive"
        v-if="isButtonShow('questionnaire/deliver-user-list')"
        class="list-btn text-nowrap ms-2"
        @click="
          $router.push(`/user-management/distribute-questionnaire/${item.id}`)
        "
      >
        派發
        <img src="@/assets/icons/bills.svg" alt="" />
      </CButton>
      <CButton
        v-if="isButtonShow('questionnaire/info')"
        color="light"
        target="_blank"
        class="list-btn mx-2 text-nowrap"
        :disabled="+item.is_archive"
        @click="toPreview(item)"
      >
        預覽
        <img src="@/assets/icons/preview.svg" alt="" />
      </CButton>
    </CCol>
  </CRow>
  <div class="d-flex align-items-center justify-content-center py-4">
    <el-pagination
      background
      layout="prev, pager, next"
      :total="pagination.totalCount"
      :page-size="pagination.pageSize"
      @current-change="changePage"
    />
  </div>
  <!-- <button
        class="m-3 btn btn-outline-primary que-btn col-2"
        v-for="item in enterpriseList"
        :key="item"
        @click="toAnalyze(item.questionnaire_id)"
      >
        {{ item.questionnaire_title }}
      </button> -->
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import router from '@/router'
import useQuestionnaire from '@/composables/useQuestionnaire'
import MsgBox from '@/components/MsgBox.vue'
import { ref } from '@vue/reactivity'
import { formatDate } from '@/utils/format-date.js'
import { computed } from '@vue/runtime-core'
import MessageBox from '@/plugins/MessageBox'
import { manualToggleLoading } from '@/plugins/LoadingSpinner'
import { Part_Is_Display_Yes } from '@/defines'
import { useStore } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  components: {
    MsgBox,
  },
  setup() {
    const {
      questionnaireList,
      copyQuestionnaire,
      deleteQuestionnaire,
      archiveQuestionnaire,
      publishQuestionnaire,
      getQuestionnaire,
    } = useQuestionnaire()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const enterpriseList = ref([])
    const pagination = ref({})
    const searchTitle = ref('')
    const currentPage = ref(1)
    const store = useStore()

    const SearchTitleChante = debounce(async() => {
      manualToggleLoading(true)
      const res = await questionnaireList({ page: 1, title:searchTitle.value })
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        manualToggleLoading(false)
        enterpriseList.value = res.ret.data
        pagination.value = res.ret.pagination
      }
      document.scrollingElement.scrollTop = 0
    }, 400);
   
    const getList = async () => {
      manualToggleLoading(true)
      const res = await questionnaireList({ page: currentPage.value })
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        manualToggleLoading(false)
        enterpriseList.value = res.ret.data
        pagination.value = res.ret.pagination
        pagination.value.currentPage = currentPage.value
      }
    }
    getList()
    const isButtonShow = (key) => {
      if (store.state.userInfo.auth_data === true) {
        return true
      } else {
        return Object.values(store.state.userInfo.auth_data).includes(key)
      }
    }
    const changePage = async (page) => {
      currentPage.value = page
      manualToggleLoading(true)
      const res = await questionnaireList({ page: currentPage.value })
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        manualToggleLoading(false)
        enterpriseList.value = res.ret.data
        pagination.value = res.ret.pagination
      }
      document.scrollingElement.scrollTop = 0
    }
    const list = computed(() => {
      return enterpriseList.value
    })
    const formatTimestamp = (timestamp) => {
      return formatDate(timestamp * 1000)
    }
    const toAnalyze = (id) => {
      const routeData = router.resolve({
        path: `/analyze/${id}`,
      })
      window.open(routeData.href, '_blank')
    }
    const copyQue = async (id) => {
      MessageBox({
        message: '您確定要複製此問卷？',
        onConfirm: async () => {
          const res = await copyQuestionnaire({ id: id })
          if (!res.error) {
            // location.reload()

            await getList()
          } else {
            showMsgBox.value = true
            errorMsg.value = res.msg
            errorCode.value = res.error
          }
        },
      })
    }
    const deleteQue = async (id) => {
      MessageBox({
        message: '問卷一旦刪除則無法復原，是否確定刪除問卷及相關填答結果？',
        onConfirm: async () => {
          const res = await deleteQuestionnaire({ id: id })
          if (!res.error) {
            showMsgBox.value = true
            errorMsg.value = '已刪除'
            getList()
          } else {
            showMsgBox.value = true
            errorMsg.value = res.msg
            errorCode.value = res.error
          }
        },
      })
    }
    const archiveQue = async (id, isArchive) => {
      MessageBox({
        message: +isArchive ? '是否確定解封此問卷？' : '是否確定封存此問卷',
        onConfirm: async () => {
          const res = await archiveQuestionnaire({ id: id })
          if (!res.error) {
            showMsgBox.value = true
            errorMsg.value = +isArchive
              ? '已成功解封此問卷'
              : '已成功封存此問卷'
            getList()
          } else {
            showMsgBox.value = true
            errorMsg.value = res.msg
            errorCode.value = res.error
          }
        },
      })
    }

    const canViewAnalyze = (item) => {
      return item.user_questionnaire_count > 0
    }

    const toPreview = async (info) => {
      const res = await getQuestionnaire({ id: info?.id })
      if (res.error) {
        manualToggleLoading(false)
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        const display_part = res.ret.questionnaire.parts.filter(
          (e) => e.is_display === Part_Is_Display_Yes,
        )
        if (!display_part.length) {
          showMsgBox.value = true
          errorMsg.value = '沒有可預覽的題目'
          return
        }
        const routeData = router.resolve({
          path: `/preview/${info?.id}/${display_part[0].id}`,
        })
        window.open(routeData.href, '_blank')
      }
    }
    const publishQue = async (id, status) => {
      MessageBox({
        message: `您確定要${status === '1' ? '下架' : '發布'}此問卷？`,
        onConfirm: async () => {
          const res = await publishQuestionnaire({
            id: id,
            type: status === '1' ? '2' : '1',
          })
          if (!res.error) {
            location.reload()
          } else {
            showMsgBox.value = true
            errorMsg.value = res.msg
            errorCode.value = res.error
          }
        },
      })
    }

    return {
      SearchTitleChante,
      searchTitle,
      canViewAnalyze,
      enterpriseList,
      formatTimestamp,
      toAnalyze,
      showMsgBox,
      errorMsg,
      errorCode,
      list,
      copyQue,
      deleteQue,
      archiveQue,
      publishQue,
      toPreview,
      pagination,
      currentPage,
      changePage,
      isButtonShow,
    }
  },
}
</script>
<style lang="scss" scoped>
.title-wrapper {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1%;
  box-shadow: rgb(69 69 69 / 15%) 0px 1px 4px 0px;
  margin: 0 0 10px 0;

  img {
    width: 100px;
  }
}

.header {
  padding: 40px 0px;
}

h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}

h3 {
  font-size: 22px;
  margin: 0 20px 0;
}

.que-btn {
  height: 150px;
  box-shadow: 0 1px 4px 0 rgb(69 69 69 / 20%), 0 1px 2px 0 rgb(69 69 69 / 10%);
  border-radius: 4px;
}

.list-title {
  font-size: 14px;
}

.list {
  height: 48px;
  border-radius: 20px;
}

.state {
  border-radius: 4px;
  color: #fff;
  width: 64px;
  height: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin: auto;
  justify-content: center;
}

.result {
  font-size: 12px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  white-space: nowrap;
}

.list-btn {
  font-size: 12px;
  display: flex;
  align-items: center;
  width: 64px;
  height: 24px;
  img {
    width: 16px;
    margin-left: 5px;
  }
}

.list-tips {
  cursor: no-drop;
}

.add-que {
  background: #d1e5ef;
  border-radius: 20px;
  height: 50px;
}
</style>
